import { render } from "./account-top.component.vue?vue&type=template&id=022d9bf8&ts=true"
import script from "./account-top.component.vue?vue&type=script&lang=ts"
export * from "./account-top.component.vue?vue&type=script&lang=ts"

import "./account-top.component.vue?vue&type=style&index=0&id=022d9bf8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__